import { Link } from "react-router-dom";
import { useCart } from "./cartProvider";

function CartComponent({className}) {
    const { addToCart, cartItems } = useCart();
    return (
        <div className={className} style={{display: "flex"}}>
            <Link to="/cart" style={{ textDecoration: "none", color: "inherit", margin: "5px 0px 5px 0px", position: "relative"}}>
                <span style={{ fontSize: "clamp(1rem, 4vw, 2rem)", display: "inline-block" }}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        className="bi bi-bag-heart-fill"
                        viewBox="0 0 16 16"
                        style={{ width: "1.3em", height: "1.3em" }}
                    >
                        <path d="M11.5 4v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4zM8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1m0 6.993c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132" />
                    </svg>
                </span>
                <div className="rounded-circle bg-danger d-flex justify-content-center align-items-center" style={{width: "0.65em", height: "0.65em", position: "absolute", bottom: "0", right: "0", transform: "translate(50%,50%)"}}>
                    <p className="m-auto text-light" style={{fontSize: "0.5em"}}>{cartItems.length}</p>
                </div>
            </Link>
        </div>
    );
}

export default CartComponent;